import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthEffects } from '@core/states/auth/auth.effects';
import { LOGIN_PATH } from '@features/auth/auth.routes';

export const appGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authEffects = inject(AuthEffects);

  const urlTree = router.createUrlTree([LOGIN_PATH]);

  return authEffects.isLoggedIn$().pipe(
    map(isLoggedIn => {
      if (!isLoggedIn) {
        return urlTree;
      }
      return true;
    }),
    catchError(() => of(urlTree))
  );
};
